// extracted by mini-css-extract-plugin
export default {"grid":"_16WtG___List-module__grid","flex":"_2vixC___List-module__flex"};